<template>
  <div>


    <horizontal-bar-chart
        :style=" 'width: 100%; min-height:200px; height:'+ uniqueReasons.length * 20+'px'"
        :chartData="getChartData"
        :options="getOptions"/>
  </div>
</template>

<script>
import HorizontalBarChart from '@/components/oeeAnalytics/charts/horizontalBarChart'

import {mapGetters} from "vuex";
import timeCalc from "@/mixins/timeCalc";
import generalMethods from "@/mixins/insights/generalMethods";
import downTimesOee from '@/mixins/oeeAnalytics/downTimes'
import colours from "@/mixins/oeeAnalytics/colours";

export default {
  components: {
    HorizontalBarChart
  },
  mixins: [timeCalc, generalMethods, downTimesOee,colours],
  props: ['downTimes', 'uniqueReasons'],
  data() {
    return {
      config: {
        filterDownTimeType: false
      }
    }
  },
  computed: {
    ...mapGetters('users', ['getClaims']),
    getOptions() {
      const self = this
      return {
        animation: {
          duration: 0 // general animation time
        },
        hover: {
          animationDuration: 100,
          intersect:false,// duration of animations when hovering an item
        },
        legend: {
          display: false,
        },
        layout: {
          padding: {
            left: 5,
            right: 5,
            top: 5,
            bottom: 5
          }
        },
        title: {
          display: true,
          text: self.$t('oeeAnalytics.downTimes.pareto.chartTitle'),
          fontSize: 20,
          fontStyle: 'normal',
          position: 'top',
        },
        scales: {
          yAxes: [
            {
              gridLines: {
                display: false
              },
            },
          ],
          xAxes: [{
            ticks: {
              beginAtZero: true,
              callback: function (label, index, labels) {
                return self.formattedColonTime(label, false) + 'u'
              }
            }
          }],
        },
        //This will show money in tooltip with format of $xx.xx
        tooltips: {
          callbacks: {
            title: function (tooltip) {
              return tooltip[0].label
            },
            label: function (tooltipItem) {
              return self.formattedColonTime(tooltipItem.value) + 'u'    //tooltipItem.value
            }
          }
        },

        plugins: {
          datalabels: {
            color: 'black',
            anchor: 'start',
            align: 'bottom',
            font: {
              // weight: 'bold',
              size: 20
            },
            offset: -50,

            display: function (ctx) {
              return false
              return ctx.datasetIndex > 0 //ctx.chart.$totalizer.utmost;
            },
            formatter: (value, ctx) => {
              return self.getHoursFromMilliseconds(value.y, false) > 0 ? self.getHoursFromMilliseconds(value.y, false) + '' : ' '
            },
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        onClick: function (evt, el) {
          try {
            self.$emit('reasonSelected', el[0]._model.label)
          } catch (e) {

          }
        },
        onHover: (event, chartElement) => {
          event.target.style.cursor = chartElement[0] ? 'pointer' : 'default';
        },
      }

    },
    getUniqueKeys() {
      return this.getUniqueDownTimeKeys();
    },
    getDownTimes() {
      let downTimes = _.clone(this.downTimes)
      if (this.config.filterByValue) {
        return this.getFilteredDownTimes
      }
      return downTimes
    },
    getUniqueValues() {
      // return _.uniq(_.map(this.downTimes, this.config.filterByKey)).sort();

      // should loop and get values if type
      let mappedValues = _.map(this.downTimes, (dt) => {
        if (dt[this.config.filterByKey] && dt[this.config.filterByKey].length && typeof dt[this.config.filterByKey] == "object") {
          return _.uniq(dt[this.config.filterByKey])
        }
        return dt[this.config.filterByKey]
      })
      let res = _.flattenDeep(mappedValues).filter(val => {
        return val
      })

      return [...new Set(res)].sort();

    },
    // getUniqueReasons() {
    //   const self = this
    //   return [...new Set(_.clone(self.downTimes).map(dt => {
    //         // dt.reason = _.filter([dt.reason_1,dt.reason_2,dt.reason_3], rs=>{ return rs !== null})
    //         try {
    //           if (dt.reason) {
    //             return this.joinReasonsToString(dt.reason)
    //           }
    //         } catch (e) {
    //
    //         }
    //       }
    //   ))].filter(Boolean)
    // },
    getChartData() {

      let labels = this.uniqueReasons
      let datasets = [
        {
          label: 'Reasons',
           backgroundColor: this.getOeeColours('availability'), //,this.colors.downTimes.reasons,
          data: new Array(labels.length).fill(0)
        }]

      _.each(this.downTimes, dt => {

        // Filters out all the out planned downtimes
        // for example during weekends or nights
        if (!this.config.filterDownTimeType && dt.planned) {
          return
        }
        if (dt.downTimeEnded) {
          let diff = moment(dt.downTimeEnded).diff(moment(dt.downTimeStart))
          let index = _.findIndex(labels, label => {
            // reasons seperated by pipeline
            if (dt.reason) {
              return label === this.joinReasonsToString(dt)
            }
          })
          if (index >= 0) {
            datasets[0].data[index] += diff
          } else {
            datasets[0].data[index] = diff
          }
          // get index of label
        }
      })

      const arrayOfObj = labels.map(function (d, i) {
        return {
          label: d,
          data: datasets[0].data[i],
        }
      })

      const sortedArrayOfObj = arrayOfObj.sort(function (a, b) {
        return b.data - a.data
      })

      let newArrayLabel = []
      let newArrayData = []
      sortedArrayOfObj.forEach(function (d) {
        if (d.data > 0) {
          newArrayLabel.push(d.label)
          newArrayData.push(d.data)
        }
      })
      datasets[0].data = newArrayData

      return {
        labels: newArrayLabel,
        datasets,
      }
    },
  },
  methods: {},
  watch: {},
  created() {
  }
}
</script>


<style scoped lang="scss">


.chart-container {
  height: calc(100%)
}


.fa-chevron-square-left, .fa-chevron-square-right {
  font-size: 3rem;
  font-weight: 300;
  line-height: 1.5;
  cursor: pointer;
}

@media only screen and (max-width: 800px) {
  .chart-container {
    height: calc(100% - 10rem)
  }
}
</style>